import React from 'react';
import { Box, Typography, Card, CardContent, Grid, Button, Avatar } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { VENDOR_META, getVendorIcon } from './agentMeta';

/** Shown when the tenant has no agents yet. */
const EmptyState = ({ types = [], canManage, onAdd }) => {
  const vendors = types.length ? types.map((t) => t.type) : Object.keys(VENDOR_META);
  return (
    <Card>
      <CardContent sx={{ textAlign: 'center', py: 5 }}>
        <Typography variant="h5" gutterBottom>Connect your EDR platform</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 640, mx: 'auto' }}>
          Excubia ingests alerts, enriches detections with endpoint and threat-intelligence context, and lets you
          isolate endpoints straight from a case. Add your first integration to get started.
        </Typography>

        <Grid container spacing={3} justifyContent="center" sx={{ mb: 4 }}>
          {vendors.map((type) => {
            const meta = VENDOR_META[type] || {};
            const serverType = types.find((t) => t.type === type);
            return (
              <Grid item xs={12} sm={4} key={type}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2 }}>
                  <Avatar sx={{ bgcolor: meta.color || 'primary.main', width: 56, height: 56, mb: 1.5 }}>
                    {getVendorIcon(type, { fontSize: 'large' })}
                  </Avatar>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {(serverType && serverType.label) || meta.label || type}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">{meta.setupHint}</Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>

        {canManage ? (
          <Button variant="contained" size="large" startIcon={<AddIcon />} onClick={onAdd}>Add integration</Button>
        ) : (
          <Typography variant="body2" color="text.secondary">Ask a company administrator to add an integration.</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default EmptyState;
